module.exports = __webpack_public_path__ + "img/u106.f5aa5a32.png";